// 优惠卷-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :type="editViewType" :_dataId.sync="dataId"
          :parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div style=" height: calc(100vh - -42px);">
          <vxe-grid show-overflow :stripe="true" border="default" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption" height="100%"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                    @click="openEditDialog(null, 'edit')">新增
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                    @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="5vw" title-align="right" :data="formData"
                @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.stat" clearable >
                      <el-option label="全部" :value="null"></el-option>
                      <el-option :value="1" label="待审核"></el-option>
                      <el-option :value="2" label="已审核"></el-option>
                      <el-option :value="9" label="作废"></el-option>
                    </el-select>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>
            </template>

            <template #option="{ row }">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id, 'edit')">
                <el-tooltip  effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                  <i class="el-icon-edit" />
                </el-tooltip>
              </a>

              <el-dropdown @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="审核" v-if="row.stat == 1">审核</el-dropdown-item>
                  <el-dropdown-item command="作废" v-if="row.stat == 1">作废</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>

          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
        <span>{{dialogMsg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmCheck()">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
// 假数据
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'
export default {
  name: 'coupon',

  inject: ['reload'],
  components: { editView, pager, },
  data() {
    return {
      total: 0,
      editViewType: null,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        stat: null,       
        createDateBegin: null,
        createDateEnd: null,        

        fuzzySearchIsEnable: true,
        fuzzySearchValue: null,
      },

      formData: {
        stat: null,       
        createDate: null,
        fuzzySearchValue: null
      },

      sitePromptList: [],

      goodsStatusList: [ //循环列表
        { name: "待审核", num: 1 },
        { name: "审核中", num: 0 },
        { name: "驳回", num: 0 },
        { name: "全部", num: null },
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      dialogMsg: null,
      dialogVisible: false,
      currentRow: false,

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '优惠卷名称', field: 'couponName', width: 180, 
        },
        {
          title: '优惠卷金额', field: 'couponAmount', width: 180, 
        },
        { title: '状态', field: 'stat', width: 125, slots: {
            default: ({ row }) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status disable">
                    <span>待审核</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status">
                    <span>已审核</span>
                  </div>
                ];
              }else if (row.stat == 9) {
                return [
                  <div class="txt-status neutral">
                    <span>作废</span>
                  </div>
                ];
              }
            }
          } },
 
        { title: '每人限领张数', field: 'limitQty', width: 100, },
        { title: '发放总量', field: 'qty', width: 100, },
        { title: '已发放数量', field: 'sendQty', width: 100, },
        { title: '已使用数量', field: 'usedQty', width:100, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },


      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.getTableData()
    //   }
    // },

  },
  created() {
    this.checkButton = this.permissions["checkButton"];
    console.log(this.checkButton, "this.checkButton");
  },

  mounted() {
    this.initSearchDate()
    // this.loadTabOption()
    this.getTableData()
  },

  methods: {
    toFilterData() {
            this.searchEvent();
     },
    // tab也切换为列表页
    goBackIndex() {
      this.activeName = 'second'
      this.showEdit = false
      this.flushed()
    },

    confirmCheck() {
      if(this.stat==1){
        this.$http({
          url: api.slCoupon.checkCouponUrl,
          method: 'post',
          data: {
            id: this.currentRow.id,
            // stat: this.stat
          }
        }).then(res => {
          this.$message.success('操作成功')
          this.flushed()
        })
        this.dialogVisible = false
      }else if(this.stat==9){
        this.$http({
          url: api.slCoupon.cancelCouponUrl,
          method: 'post',
          data: {
            id: this.currentRow.id,
            // stat: this.stat
          }
        }).then(res => {
          this.$message.success('操作成功')
          this.flushed()
        })
        this.dialogVisible = false
      }
      
    },

    flushed() {
      // this.loadTabOption()
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: { userName: queryStr }
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({ value: item.userName, id: item.id })
        })
        callback(temp)
      })
    },


    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.spPartsApplyHeader.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        // this.goodsStatusList = res.data.data
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      let s = null
      if (item.name === '待审核') {
        s = 1
      } else if (item.name === '待发货') {
        s = 2
      } else if (item.name === '待签收') {
        s = 3
      }

      this.showStat = item.name === '所有'

      this.requestParam.type = item.name
      if (item.name !== '所有') {
        this.requestParam.stat = null
        this.formData.stat = null
      }
      
      this.requestParam.stat = s
      this.formData.stat = s
      this.flushed()
    },


    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.slCoupon.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      // this.requestParam.fuzzySearchIsEnable = !this.showMoreOptions

      let formData = this.formData
      this.requestParam.stat = formData.stat

      // if (formData.createDate !== null && formData.length !== 0) {
      //   this.requestParam.createDateBegin = formData.createDate[0]
      //   this.requestParam.createDateEnd = formData.createDate[1]
      // }

      // if (formData.checkDate !== null && formData.checkDate.length !== 0) {
      //   this.requestParam.checkDateBegin = formData.checkDate[0]
      //   this.requestParam.checkDateEnd = formData.checkDate[1]
      // }

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 操作
    handleCommand(command, row) {
      this.currentRow = row
      console.log(command, row, "command,b的值");
      if (command === '审核') {
        this.dialogMsg = '确定审核吗？'
        this.stat = 1
        this.dialogVisible = true
      }else if(command === '作废'){
        this.dialogMsg = '确定作废吗？'
        this.stat = 9
        this.dialogVisible = true
      }
    },


    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row.id, 'info')
    },

    // 新增/修改
    openEditDialog(id, type) {
      this.editViewType = type
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },




    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },



    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },




  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

// ::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
//   display: inline-block;
//   width: 20%;
// }

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
